var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnreadMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_767",
    "data-name": "Group 767",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.427,
    height: 69.334,
    viewBox: "0 0 87.427 69.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3929",
    "data-name": "Path 3929",
    d: "M-413.616,292.838q-15.546,0-31.093,0a10.559,10.559,0,0,1-11.02-11q0-22.189,0-44.378a10.55,10.55,0,0,1,10.979-10.944q21.529,0,43.059,0a3.006,3.006,0,0,1,3.048,4.049,2.978,2.978,0,0,1-2.731,1.965c-1.036.027-2.073.007-3.109.007h-40.232c-3.135,0-4.99,1.842-4.99,4.956q0,22.189,0,44.378a4.556,4.556,0,0,0,4.909,4.943q31.14,0,62.279,0c3.083,0,4.958-1.886,4.96-5.006q.009-12.484-.006-24.968a3.232,3.232,0,0,1,1.015-2.618,2.98,2.98,0,0,1,4.847,1.384,4.838,4.838,0,0,1,.166,1.3c.009,8.354.03,16.708,0,25.063a10.452,10.452,0,0,1-5.155,9.36,10.273,10.273,0,0,1-5.548,1.511Q-397.928,292.836-413.616,292.838Z",
    transform: "translate(455.73 -223.506)",
    fill: "#d10a11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3930",
    "data-name": "Path 3930",
    d: "M-107.7,234.661A12.076,12.076,0,0,1-119.71,222.6a12.1,12.1,0,0,1,12.043-12.044A12.092,12.092,0,0,1-95.6,222.671,12.092,12.092,0,0,1-107.7,234.661Z",
    transform: "translate(183.03 -210.555)",
    fill: "#d10a11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3931",
    "data-name": "Path 3931",
    d: "M-361.647,317.8a10.057,10.057,0,0,1-1.9-.9q-13.512-10.452-26.982-20.959a2.989,2.989,0,0,1-.643-4.26,2.973,2.973,0,0,1,4.417-.426q11.382,8.822,22.742,17.671c.594.462,1.218.892,1.773,1.4.46.419.779.391,1.275.013,4.54-3.462,9.106-6.89,13.658-10.337a3.031,3.031,0,0,1,3.5-.411,2.874,2.874,0,0,1,1.568,2.795,3.3,3.3,0,0,1-1.567,2.547q-5.491,4.13-10.972,8.272c-1.628,1.227-3.237,2.482-4.9,3.661A12.63,12.63,0,0,1-361.647,317.8Z",
    transform: "translate(403.845 -275.412)",
    fill: "#d10a11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadMsgIcon);
export default __webpack_public_path__ + "static/media/UnreadMsgIcon.d8708dfd3c92f390d1b50dff6573cc4f.svg";
export { ForwardRef as ReactComponent };